// services/graphqlService.js
export function sendGraphQLRequest() {
  const sendRequest = async function(query) {
    const rawBody = JSON.stringify(query || {})
      .replace(/[\n\r\t\s]+/g, "") // supprime espaces, tabulations, retours à la ligne
      .replace(/\\n/g, "")
      .replace(/"/g, "") // supprime les guillemets
      .replaceAll("\\", '"');

    let signature = '';
    let timestamp = '';

    try {
      const res = await fetch(`${process.env.VUE_APP_DOMAIN}/api/secret`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ queryBody: rawBody }),
      });
      const data = await res.json();
      signature = data.signature;
      timestamp = data.timestamp;
    } catch (e) {
      console.error('Erreur lors de la signature :', e);
      throw new Error('Impossible de signer la requête.');
    }

    const response = await fetch(process.env.VUE_APP_API_URL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${process.env.VUE_APP_API_TOKEN}`,
        'X-Signature': signature,
        'X-Timestamp': timestamp
      },
      body: JSON.stringify({ query: query })
    });

    return response.json();
  };

  return { sendRequest };
}
